import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { trackPage } from '../utils/tracker';

/**
 * Fires page_view on SPA navigations (GTM dataLayer, GA4, Meta Pixel, first-party tracker).
 */
export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, location.search);
    trackPage(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
